import { useCallback, useEffect, useRef, useState } from 'react'
import { apiPost } from '~/util/api'

export const AYLA_TIMEOUT_MS = 90000
export const AYLA_MAX_POLL_FAILURES = 5

export const aylaPost = (url, data, multipart = false) =>
  apiPost(url, data, multipart, { timeout: AYLA_TIMEOUT_MS })

const useAylaTimeout = ({ waiting, activity }) => {
  const [timedOut, setTimedOut] = useState(false)
  const pollFailures = useRef(0)

  useEffect(() => {
    if (!waiting || timedOut) return

    const timer = setTimeout(() => setTimedOut(true), AYLA_TIMEOUT_MS)
    return () => clearTimeout(timer)
  }, [waiting, activity, timedOut])

  const pollFailed = useCallback(() => {
    pollFailures.current += 1
    if (pollFailures.current >= AYLA_MAX_POLL_FAILURES) setTimedOut(true)
  }, [])

  const pollSucceeded = useCallback(() => {
    pollFailures.current = 0
  }, [])

  const resetTimeout = useCallback(() => {
    pollFailures.current = 0
    setTimedOut(false)
  }, [])

  return { timedOut, resetTimeout, pollFailed, pollSucceeded }
}

export default useAylaTimeout
